import { useContext } from 'react';

import { ApparelTypeStateContext } from './ApparelTypeContextProvider';

import ApparelTypeData from './ApparelTypeData';

const useApparelTypeData = () => {
  const [apparelTypeState, setApparelTypeState] = useContext(ApparelTypeStateContext);

  const getApparelTypes = async () => {
    const apparelTypeResultState = await ApparelTypeData.getApparelTypesData(apparelTypeState, setApparelTypeState);

    if (apparelTypeResultState) {
      const options = apparelTypeResultState.arrayData.map((x) => { return { id: x.nationalTeamApparelId, name: x.apparelName, hasGenderType: x.hasGenderType, displayOrder: x.displayOrder } })

      let newState = {
        ...apparelTypeResultState,
        options,
        areOptionsLoaded: true
      };
      
      setApparelTypeState({ ...newState });

      return newState;
    }

    return null;
  };

  return {
    apparelTypeState,
    getApparelTypes
  };
};

export default useApparelTypeData;